import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { useParams } from 'react-router';
import HoverImage from 'react-hover-image/build';

import useAxios from 'hooks/useAxios';
import Drawer from 'components/Drawer';
import commonColumns, { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import FaxSentIcon from 'assets/icon/faxSent.svg';
import FaxSentIconHover from "assets/icon/faxSent-hover.svg";
import Comments from '../../../../common/Comments';
import ErrorBoundary from 'components/ErrorBoundary';
import ReactStrapTable from 'components/reactStrapTable';
import FaxReceivedIcon from 'assets/icon/faxReceived.svg';
import FaxReceivedIconHover from "assets/icon/FaxReceivedIcon-Hover.svg";
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import { cloneDeep } from 'lodash';
import ToolTip from 'react-tooltip-lite';
import FaxViewer from 'components/FaxViewer';

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: 'desc',
  filters: [],
};

const CloseMatch = ({ claimsIDsObj, claimIDs, refresh, orgId, patientId, tenantID, coveredEntity
}) => {
  const API = useAxios();
  // const { patientId, tenantID } = useParams();
  const [isOpen, setOpen] = useState(false);
  const [claim, setClaim] = useState({});
  const [closeMatchClaims, setCloseMatchClaims] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);
  const [pdfModal, setPdfModel] = useState(false);
  const [fax, setFaxDetail] = useState({});
  const [selectedTenentID, setSelectedTenentID] = useState({});

  const fetchPatientDetails = async (filters = {}, hasFilter) => {
    if (hasFilter) {
      initialFilters = { ...filters };
      initialFilters.filters = filters.filters;
    } else {
      initialFilters = { ...initialFilters, ...filters };
    }
    if (claimsIDsObj.claims) {
      initialFilters.external = {
        claimIDs: [...claimIDs, ...claimsIDsObj.closeMatches],
      };
    }
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/CloseMatch/${parseInt(patientId)}`,
        initialFilters
      );
      if (data) {
        setCloseMatchClaims(data.items);
        setTotalSize(data.totalRecords);
      }
    } catch (error) { }
  };

  useEffect(() => {
    return () => {
      initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: '',
        order: '',
        filters: [],
      };
    };

  });

  useEffect(() => {
    setCloseMatchClaims([]);
    fetchPatientDetails();
  }, [claimsIDsObj.closeMatches, claimsIDsObj.claims]);

  useEffect(() => {
    claimsIDsObj.closeMatches = [];
    claimsIDsObj.claims = [];
    initialFilters = {
      ...initialFilters,
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
      external: {
        claimIDs: [],
      },
    };
    setTotalSize(0);
    setInitFilter(initialFilters);
    setCloseMatchClaims([]);

    setSelectedTenentID({ "tenantID": tenantID });

  }, [refresh]);

  const toggleDrawer = (claim) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  const attachFile = (claim) => {
    return (
      <div className='d-flex align-items-center'>
        <Button
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => toggleDrawer(claim)}
        >
          <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt='' />
        </Button>
        {claim.isFaxSent && (
          <div className='p-0 ms-0'>
            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => previewFaxInfo(claim, 'outboundfax')}

            >
              <HoverImage
                key='FaxSentIcon'
                src={FaxSentIcon}
                hoverSrc={FaxSentIconHover}
                alt=''
              />
            </Button>
            {/* <img src={FaxSentIcon} alt='fax sent' />*/}
          </div>
        )}
        {claim.isFaxReceived && (
          <div className='p-0 ms-0'>

            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => previewFaxInfo(claim, 'inboundfax')}

            >
              <HoverImage
                key='FaxReceivedIcon'
                src={FaxReceivedIcon}
                hoverSrc={FaxReceivedIconHover}
                alt=''
              />
            </Button>
            {/* <img src={FaxReceivedIcon} alt='fax sent' />*/}
          </div>
        )}
      </div>
    );
  };


  const previewFaxInfo = async (row, faxdirection) => {
    try {
      let payload = {};
      payload.FaxDetailID = faxdirection === "outboundfax" ? row.outboundLastFaxId : row.inboundLastFaxId;
      const result = await API.post(
        `/${tenantID}/fax/patientfaxinfo/${row.coveredEntityID}`, payload);
      if (result) {
        setPdfModel(!pdfModal);
        setFaxDetail(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const togglePdfModal = () => {
    setPdfModel(!pdfModal);
  };
  const formatter = (row, columnName) => {
    return <>{row[columnName] || '-'}</>;
  };

  const toolTipFormatter = (row) => {
    const { patientFirstName, ndc, drugName, qtyDispensed, providerFirstName, providerLastName, providerSpecialty, dateRXWritten, totalPaid, dispensingFee, ceReceivable, drugCost340B, profitLoss, dateofService, providerComments } = row;
    return (

      <ToolTip content={(
        <div className='tip-list-info'>
          <p>NDC <span> {ndc} </span></p>
          <p>Drug Name<span> {drugName} </span></p>
          <p>Dispensed Qty <span> {qtyDispensed} </span></p>
          <p>Date Rx Written <span> {dateFormate(dateRXWritten)} </span></p>
          <p>Date of Service <span> {dateFormate(dateofService)} </span></p>
          <p>Total Paid <span> {currencyFormat(totalPaid)} </span></p>
          <p>Dispensing Fee <span> {currencyFormat(dispensingFee)} </span></p>
          <p>CE Receivable  <span> {currencyFormat(ceReceivable)} </span></p>
          <p>340B Drug Cost <span> {currencyFormat(drugCost340B)} </span></p>
          <p>Profit/Loss <span> {currencyFormat(profitLoss)} </span></p>
          <p>Provider Name <span> {providerFirstName + " " + providerLastName} </span></p>
          <p>Provider Specialty<span> {providerSpecialty} </span></p>
          <p>Provider Comments <span> {cellRendererCheck(providerComments)} </span></p>
        </div>
      )}
        direction="down"
        tagName="span"
        className="target"
        tipContentClassName="">
        <span>
          {patientFirstName}
        </span>
      </ToolTip>
    );
  };

  // let copyCommonColumns = cloneDeep(commonColumns);

  let copyCommonColumns = [
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      cellRenderer: (rowData) => cellRendererCheck(rowData.patientFirstName),
      sort: false,
      width: 175,
      show: true,
      inputType: 'text',
      // hideColFilter: true,
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      sort: false,
      width: 175,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.patientLastName),
    },
    {
      dataField: "patientDOB",
      text: "Patient DOB",
      sort: false,
      width: 120,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.patientDOB),
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.medicalRecordNumber),
    },
    {
      dataField: "claimStatus",
      text: "Claim Status",
      sort: false,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimStatus),
      width: 130,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true,
    },
    {
      dataField: "reasonDesc",
      text: "Reason",
      sort: false,
      cellRenderer: (rowData) => cellRendererCheck(rowData.reasonDesc),
      width: 240,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true,
    },
    {
      dataField: "rxNumber",
      text: "RX Number",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.rxNumber),
    },
    {
      dataField: "refillNumber",
      text: "Refill Number",
      sort: false,
      width: 110,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.refillNumber),
    },
    {
      dataField: "dateRXWritten",
      text: "Date Rx Written",
      cellRenderer: (rowData) => dateFormate(rowData.dateRXWritten),
      sort: false,
      width: 120,
      show: true,
      inputType: "date",
      // hideColFilter: true,
    },
    {
      dataField: "dateofService",
      text: "Date of Service",
      cellRenderer: (rowData) => dateFormate(rowData.dateofService),
      sort: false,
      width: 120,
      show: true,
      inputType: "date",
      // hideColFilter: true,
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 110,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
    },
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugName),
    },
    {
      dataField: "qtyDispensed",
      text: "Qty Dispensed",
      sort: false,
      width: 120,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.qtyDispensed),
    },
    {
      dataField: "daysSupply",
      text: "Days Supply",
      sort: false,
      width: 100,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.daysSupply),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN Sequence Number",
      sort: false,
      width: 150,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.gcnSequenceNumber),
    },
    {
      dataField: "manufacturerName",
      text: "Manufacturer Name",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.manufacturerName),
    },
    {
      dataField: "drugStatusDesc",
      text: "Drug Status Desc",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugStatusDesc),
    },
    {
      dataField: "claimType",
      text: "Claim Type",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimType),
    },
    {
      dataField: "claimSubType",
      text: "Claim Sub Type",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimSubType),
    },
    {
      dataField: "sourceReason",
      text: "Source Reason",
      sort: false,
      width: 120,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceReason),
    },
    {
      dataField: "totalPaid",
      text: "Total Paid",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.totalPaid),
      className: "text-end",
    },
    {
      dataField: "dispensingFee",
      text: "Dispensing Fee",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.dispensingFee),
      className: "text-end",
    },
    {
      dataField: "ceReceivable",
      text: "CE Receivable",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.ceReceivable),
      className: "text-end",
    },
    {
      dataField: "drugCost340B",
      text: "Drug Cost 340B",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.drugCost340B),
      className: "text-end",
    },
    {
      dataField: "profitLoss",
      text: "Profit/Loss",
      sort: false,
      width: 125,
      textAlign: "right",
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => currencyFormat(rowData.profitLoss),
      className: "text-end",
    },
    {
      dataField: "rcsFeeAmt",
      text: "RCS Fee Amount",
      cellRenderer: (rowData) => currencyFormat(rowData.rcsFeeAmt),
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter: true,
      className: "text-end",
    },
    {
      dataField: "netProfit",
      text: "Net Savings",
      cellRenderer: (rowData) => currencyFormat(rowData.netProfit),
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      className: "text-end",
      hideColFilter: true,
    },
    {
      dataField: "hasVisit",
      text: "Eligible Visit",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.hasVisit),
      hideColFilter: true,
    },
    {
      dataField: "providerNPI",
      text: "Provider NPI",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerNPI),
    },
    {
      dataField: "providerFirstName",
      text: "Provider First Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerFirstName),
    },
    {
      dataField: "providerLastName",
      text: "Provider Last Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerLastName),
    },
    {
      dataField: "providerSpecialty",
      text: "Provider Specialty",
      sort: false,
      width: 180,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerSpecialty),
      hideColFilter: true,
    },
    {
      dataField: "providerStatus",
      text: "Provider Status",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.providerStatus),
      hideColFilter: true,
    },
    {
      dataField: "faxNumber",
      text: "Fax Number",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxNumber),
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.phoneNumber),
    },
    {
      dataField: "faxCount",
      text: "Fax Count",
      sort: false,
      width: 130,
      show: true,
      inputType: "number",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.faxCount),
    },
    {
      dataField: "pharmacyNPI",
      text: "Pharmacy NPI",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyNPI),
    },
    {
      dataField: "pharmacyName",
      text: "Pharmacy Name",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
    },
    {
      dataField: "thirdPartyAdminID",
      text: "Third Party Admin",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.thirdPartyAdminID),
    },
    {
      dataField: "bin",
      text: "BIN",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.bin),
    },
    {
      dataField: "pcn",
      text: "PCN",
      sort: false,
      width: 130,
      show: true,
      // hideColFilter: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.pcn),
    },
    {
      dataField: "groupNumber",
      text: "Group Number",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.groupNumber),
    },
    {
      dataField: "secondaryBIN",
      text: "Secondary BIN",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryBIN),
    },
    {
      dataField: "secondaryPCN",
      text: "Secondary PCN",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryPCN),
    },
    {
      dataField: "secondaryGroup",
      text: "Secondary Group",
      sort: false,
      width: 130,
      show: true,
      inputType: "text",
      // hideColFilter: true, 
      cellRenderer: (rowData) => cellRendererCheck(rowData.secondaryGroup),
    },

    {
      dataField: "createdDate",
      text: "Created Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
    {
      dataField: "createdByID",
      text: "Created By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.createdBy),
      hideColFilter: true,
    },
    {
      dataField: "claimStatusChangeDate",
      text: "Status Change Date",
      sort: false,
      width: 125,
      show: true,
      hideColFilter: true,
      inputType: "date",
      cellRenderer: (rowData) => dateFormate(rowData.claimStatusChangeDate),
    },
    {
      dataField: "statusChangedBy",
      text: "Status Changed By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.statusChangedBy),
      // hideColFilter: true,
    },
    {
      dataField: "completedDate",
      text: "Completed Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.completedDate),
    },
    {
      dataField: "completedBy",
      text: "Completed By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.completedBy),
      hideColFilter: true,
    },
    {
      dataField: "invoicedDate",
      text: "Invoiced Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.invoicedDate),
    },
    {
      dataField: "invoicedBy",
      text: "Invoiced By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.invoicedBy),
      hideColFilter: true,
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: false,
      width: 125,
      show: true,
      inputType: "date",
      // hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
    },
    {
      dataField: "modifiedByID",
      text: "Modified By",
      sort: false,
      width: 125,
      show: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.modifiedBy),
      // hideColFilter: true,
    },
    {
      dataField: "claimID",
      text: "Claim ID",
      sort: false,
      width: 125,
      show: true,
      inputType: "number",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimID),
    },
    {
      dataField: "sourceClaimID",
      text: "Source Claim ID",
      sort: false,
      width: 150,
      show: true,
      // hideColFilter: true,
      inputType: "text",
      cellRenderer: (rowData) => cellRendererCheck(rowData.sourceClaimID),
    },
    {
      dataField: "claimReferenceID",
      text: "Claim Reference ID",
      sort: false,
      width: 150,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.claimReferenceID),
    },
  ];


  var patientObj = {
    dataField: 'patientFirstName',
    text: 'Patient First Name',
    cellRenderer: (rowData) => toolTipFormatter(rowData),
    sort: false,
    width: 144,
    show: true,
    inputType: 'text',
    hideColFilter: true,
  };

  copyCommonColumns.splice(0, 1, patientObj);

  const columns = [
    {
      dataField: 'attachement',
      text: 'Options',
      cellRenderer: (rowData) => attachFile(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'refRxNumber',
      text: 'Ref RX #',
      headerStyle: { width: '100px' },
      show: true,
      cellRenderer: (rowData) => formatter(rowData, 'refRxNumber'),
      inputType: 'number',
      hideColFilter: true,
      sort: false,
    },
    ...copyCommonColumns,
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let colFilterOn = { ...filter, filters: colChangedFilter };
      setInitFilter(colFilterOn);
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setInitFilter(filter);
    if (hasColFilter) {
      fetchPatientDetails(filter, true);
    } else {
      fetchPatientDetails(filter);
    }
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchPatientDetails(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    initialFilters.filters = [];
    const filter = { ...initFilter, filters: [] };
    fetchPatientDetails(filter);
    setInitFilter(filter);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let colFilterOn = { ...filter, filters: colChangedFilter };
      setInitFilter(colFilterOn);
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };
  useEffect(() => {
    if (isOpen == true) {
      setOpen(false)
    }
    if (pdfModal == true) {
      setPdfModel(false)
    }

  }, [orgId])

  return (
    <div className='table-card scroll-table position-relative border-0'>
      <ReactStrapTable
        id='close-match'
        height={50 * closeMatchClaims.length}
        fixedColumn
        columns={columns}
        data={closeMatchClaims}
        handleSort={handleSort}
        loader
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}
        datafilter={true}

      />
      <Drawer
        direction='end'
        isOpen={isOpen}
        toggle={toggleDrawer}
        title='Claim Comments'
        size="lg"
      >
        <ErrorBoundary>
          <Comments
            hasEditable={false}
            rxNumber={claim.rxNumber}
            claimData={claim}
            onClose={toggleDrawer}
            patientId={patientId}
            tenantID={tenantID}
            coveredEntityID={coveredEntity}

          />
        </ErrorBoundary>
      </Drawer>

      <Drawer
        direction='end'
        isOpen={pdfModal}
        toggle={togglePdfModal}
        title='Fax View'
        size="lg">


        <FaxViewer selectedCoveredEntity={selectedTenentID} hasReadOnly={true} fax={fax}
          hideComments={true} toggle={togglePdfModal}></FaxViewer>
      </Drawer>

      {/* <FaxViewer
        fax={fax}
        hasReadOnly={true}
        isOpen={pdfModal}
        toggle={togglePdfModal}
        selectedCoveredEntity={selectedTenentID}
        hideComments={true}
      /> */}


    </div>
  );
};

export default CloseMatch;
